import LegFareEstimateUIModel from './leg-fare-estimate';

class FareUpsellUIModel {
  constructor({
    legFare,
  }) {
    this.legFare = new LegFareEstimateUIModel(legFare);
  }
}

export default FareUpsellUIModel;
